/**
 * 天幕播放器控制：视频下载状态 + 继续播放拦截
 * 依赖 DeviceTianMuMixin 的 showTianMu、PlanId，以及组件上的 model
 *
 * 视频下载状态由 TianMuVideo.fetchPlanLibrary 通过 inject 回调同步，
 * 首次进入设备时由 PlanId 触发一次独立查询（视频组件可能尚未挂载）。
 */
import { GetTianMuDevicePlanLibrary } from '@/axios/IDevice.js'
import { warning } from '@/assets/js/common.js'
import {
  buildTianMuVideoLibraryQuery,
  hasDownloadedTianMuVideoInList,
  isTianMuContinuePlayAction,
} from '@/components/OppleDeviceTianMu/tianMuPlayer'

export default {
  data() {
    return {
      hasDownloadedTianMuVideo: false,
    }
  },

  watch: {
    PlanId(val) {
      if (this.showTianMu && val) {
        this.fetchTianMuVideoDownloadStatus()
      }
    },
    showTianMu(val) {
      if (!val) {
        this.hasDownloadedTianMuVideo = false
      } else if (this.PlanId) {
        this.fetchTianMuVideoDownloadStatus()
      }
    },
  },

  methods: {
    /** 由 TianMuVideo.fetchPlanLibrary 在已有列表数据上同步，无需重复请求 */
    syncTianMuVideoDownloadStatus(list = []) {
      this.hasDownloadedTianMuVideo = hasDownloadedTianMuVideoInList(list)
    },

    /** 仅用于视频组件挂载前的首次查询 */
    async fetchTianMuVideoDownloadStatus() {
      if (!this.showTianMu || !this.PlanId || !this.model?.VDeviceId) {
        this.hasDownloadedTianMuVideo = false
        return
      }

      try {
        const param = buildTianMuVideoLibraryQuery({
          PlanId: this.PlanId,
          VDeviceId: this.model.VDeviceId,
          ClassSku: this.model.ClassSku,
        })
        const { Result, StatusCode } = await GetTianMuDevicePlanLibrary(param)

        if (Number(StatusCode) !== this.$store.state.rightStatusCode) {
          this.hasDownloadedTianMuVideo = false
          return
        }

        this.syncTianMuVideoDownloadStatus(Result?.DataList)
      } catch (error) {
        this.hasDownloadedTianMuVideo = false
      }
    },

    /**
     * 天幕播放器 action 下发前守卫
     * @returns {boolean} true 表示已拦截，不应继续下发
     */
    guardTianMuPlayerAction(action) {
      if (!isTianMuContinuePlayAction(action)) {
        return false
      }
      if (this.hasDownloadedTianMuVideo) {
        return false
      }
      warning(this, this.$t('tianmu.noDownloadedVideo'))
      return true
    },
  },
}
